// extracted by mini-css-extract-plugin
export var currencyInput = "_o6-1";
export var currencySymbol = "_o6-0";